function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useRef, useMemo } from 'react';
import AccordionButton, { AccordionButtonInner } from '../AccordionButton/AccordionButton';
import uuid from '../../utils/uuid';
import classnames from 'classnames';
import { useAccordionContext } from '../Accordion/Accordion';
import H from '../../H/H';
var defaultRender = function defaultRender(label) {
  return /*#__PURE__*/React.createElement(H, null, label);
};
var renderPassthrough = function renderPassthrough(x) {
  return x;
};
export default function AccordionItem(_ref) {
  var labelledby = _ref.labelledby,
    defaultOpen = _ref.defaultOpen,
    title = _ref.title,
    render = _ref.render,
    button = _ref.button,
    children = _ref.children;
  var _useAccordionContext = useAccordionContext('AccordionItem'),
    namespace = _useAccordionContext.namespace,
    checked = _useAccordionContext.checked; // get the id in `useState` default value and never set it, otherwise you just
  // always get a changing uuid every time this component renders…not great, Bob.
  var id = useMemo(function () {
    return "accordion-".concat(uuid());
  }, []);
  var isChecked = checked.includes(id);

  // For the first render checked is always an empty array. Then if defaultOpen, the button will
  // dispatch an "on" event and this will rerender with isChecked == true. After context has been
  // set correctly we need to stop using the default. We don't want to use useState as that
  // would cause a third initial render for defaultOpen == true components.
  var useDefault = useRef(defaultOpen);
  if (isChecked) {
    useDefault.current = false;
  }
  var Button = button || AccordionButtonInner;
  var renderFn = button ? renderPassthrough : render || defaultRender;
  var ariaLabelledby = labelledby || id;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderFn(/*#__PURE__*/React.createElement(AccordionButton, {
    defaultOpen: defaultOpen,
    id: id,
    title: title,
    checked: isChecked
  }, Button)), /*#__PURE__*/React.createElement("section", {
    id: "".concat(id, "-content"),
    "aria-labelledby": ariaLabelledby,
    className: classnames('_dm-accordion__content auto-accordion-content', _defineProperty(_defineProperty({}, "_dm-accordion__content--".concat(namespace), namespace), "auto-accordion-content--".concat(namespace), namespace))
  }, (isChecked || useDefault.current) && children));
}